import { render, staticRenderFns } from "./UsuarioReadEmpresa.vue?vue&type=template&id=159f5b0c&scoped=true&"
import script from "./UsuarioReadEmpresa.vue?vue&type=script&lang=js&"
export * from "./UsuarioReadEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioReadEmpresa.vue?vue&type=style&index=0&id=159f5b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f5b0c",
  null
  
)

export default component.exports